import { render, staticRenderFns } from "./PdfjsInteraction.vue?vue&type=template&id=ad04605a&"
import script from "./PdfjsInteraction.vue?vue&type=script&lang=js&"
export * from "./PdfjsInteraction.vue?vue&type=script&lang=js&"
import style0 from "./PdfjsInteraction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports